var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3333V14.6667H13.3333V17.3333H0ZM0 10.6667V8H6.66667V10.6667H0ZM0 4V1.33333H6.66667V4H0ZM24.8 17.3333L19.6667 12.2C19.1333 12.5778 18.5502 12.8613 17.9173 13.0507C17.2844 13.24 16.6453 13.3342 16 13.3333C14.1556 13.3333 12.5836 12.6831 11.284 11.3827C9.98444 10.0822 9.33422 8.51022 9.33333 6.66667C9.33244 4.82311 9.98267 3.25111 11.284 1.95067C12.5853 0.650222 14.1573 0 16 0C17.8427 0 19.4151 0.650222 20.7173 1.95067C22.0196 3.25111 22.6693 4.82311 22.6667 6.66667C22.6667 7.31111 22.572 7.95022 22.3827 8.584C22.1933 9.21778 21.9102 9.80089 21.5333 10.3333L26.6667 15.4667L24.8 17.3333ZM16 10.6667C17.1111 10.6667 18.0556 10.2778 18.8333 9.5C19.6111 8.72222 20 7.77778 20 6.66667C20 5.55556 19.6111 4.61111 18.8333 3.83333C18.0556 3.05556 17.1111 2.66667 16 2.66667C14.8889 2.66667 13.9444 3.05556 13.1667 3.83333C12.3889 4.61111 12 5.55556 12 6.66667C12 7.77778 12.3889 8.72222 13.1667 9.5C13.9444 10.2778 14.8889 10.6667 16 10.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagement);
export default __webpack_public_path__ + "static/media/icon-management.422d8af0e0c741a8f807836d0a47cbfd.svg";
export { ForwardRef as ReactComponent };